import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

import { mergeMap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';

import { environment } from '@environments/environment';

import { DataAllianceConnect } from '@model/data-alliance-connect';
import { LocalService } from '@home/storage/local.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
})
export class LoadingComponent implements OnInit {
  domain: string;
  loadingError: boolean = false;
  errorMessage: string = null;
  currentEmail: string = null;

  constructor(
    @Inject('Window') private window: Window,
    private route: ActivatedRoute,
    private http: HttpClient,
    private localService: LocalService
  ) {
    this.domain = environment.apiUrl + 'alliance/';
  }

  ngOnInit(): void {
    this.currentEmail = this.getEmailFromLocalStorage();
    this.getAllianceCode();
  }

  getAllianceCode() {
    const allianceCode = this.route.snapshot.queryParams['allianceCode'];
    if (allianceCode) {
      this.redirectToAllianceStart(allianceCode);
    } else {
      console.error('not all parameters provided');
      this.loadingError = true;
    }
  }

  redirectToAllianceStart(allianceCode: string) {
    this.getUserParameter(allianceCode)
      .pipe(
        mergeMap((queryParams: any) => {
          if (!queryParams.userId || !queryParams.allianceCode) {
            return throwError(new Error('not all parameters provided'));
          }
          return this.getUrlApiStart(queryParams.userId, queryParams.allianceCode);
        })
      )
      .subscribe({
        next: (urlApiStart) => {
          this.window.location.replace(urlApiStart);
        },
        error: (err) => {
          console.error(err);
          this.loadingError = true;
        },
      });
  }

  private getUserParameter(allianceCode: string) {
    const url = `${this.domain}alliance_user_parameter?allianceCode=${allianceCode}`;
    return this.http.get(url).pipe(
      mergeMap((data: any) => {
        if (data.message) {
          return throwError(new Error(data.message));
        }
        const userParameter = data.response.paramName;
        const userId = this.route.snapshot.queryParams[userParameter];
        return of({
          userParameter: userParameter,
          userId: userId,
          allianceCode: allianceCode,
        });
      })
    );
  }

  private getUrlApiStart(userId: string, allianceCode: string) {
    const url = `${this.domain}alliance_connect?userId=${userId}&allianceCode=${allianceCode}`;
    return this.http.get(url).pipe(mergeMap((data: DataAllianceConnect) => this.handlingResponse(data)));
  }

  private handlingResponse(data: DataAllianceConnect) {
    const responseData = data.response;
    if (!responseData) {
      return throwError(new Error(data.message));
    }
    if (responseData.errors && data.message) {
      const error = responseData.errors.join('\n');
      this.errorMessage = error;
      return throwError(new Error(error));
    }
    if (!responseData.url) {
      return throwError(new Error('Error alliance_connect: null url'));
    }
    localStorage.clear();
    return of(responseData.url);
  }

  private getEmailFromLocalStorage(): string | null {
    {
      try {
        const userFromLocalStorage = this.localService.getJsonValue('user');
        const userObject = JSON.parse(userFromLocalStorage);
        return userObject.email || null;
      } catch {
        return null;
      }
    }
  }
}
